<script setup>
import BaseBubble from './Base.vue';
import { useMessageContext } from '../provider.js';
const { content, contentAttributes } = useMessageContext();
</script>

<template>
  <BaseBubble class="px-4 py-3" data-bubble-name="whatsapp-flow">
    <p class="whitespace-pre-wrap break-words">{{ content }}</p>
    <p class="mt-2 text-sm text-n-slate-11">
      {{
        contentAttributes.whatsappFlow.name ||
        contentAttributes.whatsappFlow.flowId
      }}
    </p>
    <p
      class="mt-2 rounded-lg border border-n-weak px-3 py-2 text-center font-medium"
    >
      {{ contentAttributes.whatsappFlow.flowCta }}
    </p>
  </BaseBubble>
</template>
